import React from "react";
import { Box, Typography } from "@mui/material";
import config from "../../../../../config";

function MissionHeader({ mission }) {
  return (
    <>
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2rem", md: "3rem" },
          fontWeight: 900,
          color: config.PRIMARY_COLOR,
          mb: 1,
          letterSpacing: 1,
          textShadow: "0 2px 12px #b3b3b3a0",
          textAlign: "center",
        }}
      >
        {mission?.name} Submission
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.5rem" },
          color: "#333",
          mb: 3,
          fontWeight: 400,
          textAlign: "center",
        }}
      >
        {mission?.task?.type === "mcq"
          ? "Answer the MCQ questions below"
          : "Download the mission, watch the timer, and upload your solution below"}
      </Typography>
    </>
  );
}

export default MissionHeader;
